import React from "react";
import { Mail, MessageSquareText } from "lucide-react";
import { useSEO } from "@/lib/useSEO";
import LegalPageLayout, { LegalSection } from "@/components/LegalPageLayout";

export default function ContactPage() {
  useSEO({
    title: "Contact Us — KARM",
    description: "Get in touch with the KARM team.",
    path: "/contact",
  });

  return (
    <LegalPageLayout eyebrow="Get in touch" title="Contact Us">
      <LegalSection heading="General &amp; support queries">
        <p className="flex items-center gap-2">
          <Mail className="h-4 w-4 text-foreground shrink-0" />
          <a href="mailto:hello@karm.day" className="underline text-foreground" data-testid="contact-email-link">
            hello@karm.day
          </a>
        </p>
        <p>We typically reply within 1–2 business days.</p>
      </LegalSection>

      <LegalSection heading="For employers &amp; GCCs">
        <p className="flex items-center gap-2">
          <MessageSquareText className="h-4 w-4 text-foreground shrink-0" />
          Want your GCC's openings listed on KARM, or spot an inaccurate listing? Email us at the
          address above with the company name and role details.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
